// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d2ec1430","239":"4bf86bd8","455":"85d3f37e"}[chunkId] + ".chunk.js";
};